import { memo, Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { HiOutlineTrash } from 'react-icons/hi';

import theme from '@styles/theme';
import { HeaderType } from '@utils/types';
import NO_IMAGE from '@assets/images/empty.png';

import * as E from '@pages/Equipment/Equipment.style';
import { FlexBox, RegularFont } from '@components/styled/StyledComponents';
import { TableRow, TableCell } from '@components/share/Table/table.style';
import StyledRadio from '@components/styled/StyledRadio';

type MediaListRowProps = {
    header: HeaderType[];
    data: any;
    onChange: (radioKey: string, value: number) => void;
    onDelete: (id: number) => void;
    radioGroup: Record<string, boolean>;
    radioKey: string;
    imgWidth?: number;
    imgHeight?: number;
};
const MediaListRow = ({
    header = [],
    data,
    onChange,
    onDelete,
    radioGroup,
    radioKey,
    imgWidth,
    imgHeight
}: MediaListRowProps) => {
    return (
        <TableRow $padding="15px 0" $default>
            <TableCell $minWidth={header[0].minWidth} $width={header[0].width}>
                <FlexBox $gap={8}>
                    <E.Thumbnail
                        src={`${data?.img}/${imgWidth}/${imgHeight}`}
                        onError={(
                            e: React.SyntheticEvent<HTMLImageElement, Event>
                        ) => {
                            e.currentTarget.src = NO_IMAGE;
                        }}
                        alt="썸네일"
                        $width={imgWidth}
                        $height={imgHeight}
                    />
                    <FileName>
                        {data?.filename
                            ? `${data?.filename} ${
                                  data.filesize ? `(${data.filesize}MB)` : ''
                              }`
                            : '-'}
                    </FileName>
                </FlexBox>
            </TableCell>
            <TableCell $minWidth={header[1].minWidth} $width={header[1].width}>
                <FlexBox $gap={20}>
                    {[
                        { name: '사용', value: 1 },
                        { name: '미사용', value: 0 }
                    ].map((option, index) => (
                        <StyledRadio
                            key={`${index}-${radioKey}`}
                            name={`${radioKey}`}
                            radioId={`${radioKey}-${option.value}`}
                            label={option.name}
                            value={option.value}
                            checked={
                                radioGroup[radioKey] === true
                                    ? 1
                                    : radioGroup[radioKey] === false
                                    ? 0
                                    : null
                            }
                            onChange={(e) =>
                                onChange(radioKey, +e.target.value)
                            }
                        />
                    ))}
                </FlexBox>
            </TableCell>
            <TableCell
                $minWidth={header[2].minWidth}
                $width={header[2].width}
                $fontColor={theme.colors.deepGrayFontColor}
            >
                <Button onClick={() => onDelete(data.id)}>
                    <HiOutlineTrash size={20} color={theme.colors.activePink} />
                </Button>
            </TableCell>
        </TableRow>
    );
};

export default memo(MediaListRow);

const FileName = styled(RegularFont)`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
const Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
`;
